import ActiveItem from './ActiveItem';
import ItemBullet from './ItemBullet';
import { ProcessedActivity } from './declarations/Activity';
import type { Item as ItemType } from './declarations/Item';
import type { PositionInfo } from './declarations/PositionInfo';

export default class Item implements ItemType {
  public id: string;
  public activity: ProcessedActivity;
  public activeItem: ActiveItem;
  public itemBullet: ItemBullet;

  constructor(positionInfo: PositionInfo, activity: ProcessedActivity) {
    this.id = positionInfo.id;

    //console.log(`Item ${this.id}`, positionInfo, activity);

    this.activity = activity; //todo remove and use getActivityById ???

    this.activeItem = new ActiveItem(positionInfo.id, { x: positionInfo.x, y: positionInfo.y }, positionInfo.hit);
    this.itemBullet = new ItemBullet(positionInfo.hint, activity.title.replace(/\n/g, ' '), String(activity.day));
  }
}
